import { useNetworkState as useNetworkStateFromReactUse } from "react-use";

export const useNetworkState = () => {
	const { online, previous } = useNetworkStateFromReactUse();

	return { online, previous };
};
